var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/accordion/accordion.tsx";
import classNames from 'clsx';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { HStack, Icon, Text } from 'soapbox/components/ui';
import DropdownMenu from 'soapbox/containers/dropdown-menu-container';
const messages = defineMessages({
  collapse: {
    "id": "accordion.collapse",
    "defaultMessage": "Collapse"
  },
  expand: {
    "id": "accordion.expand",
    "defaultMessage": "Expand"
  }
});

/**
 * Accordion
 * An accordion is a vertically stacked group of collapsible sections.
 */
const Accordion = _ref => {
  let {
    headline,
    children,
    menu,
    expanded = false,
    onToggle = () => {}
  } = _ref;
  const intl = useIntl();

  const handleToggle = e => {
    onToggle(!expanded);
    e.preventDefault();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white dark:bg-primary-800 text-gray-900 dark:text-gray-100 rounded-lg shadow dark:shadow-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleToggle,
    title: intl.formatMessage(expanded ? messages.collapse : messages.expand),
    "aria-expanded": expanded,
    className: "px-4 py-3 font-semibold flex items-center justify-between w-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }, headline), /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 9
    }
  }, menu && /*#__PURE__*/React.createElement(DropdownMenu, {
    items: menu,
    src: require('@tabler/icons/dots-vertical.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    src: expanded ? require('@tabler/icons/chevron-up.svg') : require('@tabler/icons/chevron-down.svg'),
    className: "text-gray-700 dark:text-gray-600 h-5 w-5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'p-4 rounded-b-lg border-t border-solid border-gray-100 dark:border-primary-900': true,
      'h-0 hidden': !expanded
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  }, children)));
};

export default Accordion;